import moment, { Moment } from 'moment-timezone';
import { useQueryParam, withDefault, StringParam } from 'use-query-params';

type addStartAfterDateProps = {
  date: Moment;
};

interface IUseStartAfterDate {
  startsDate: string;
  date: Moment;
  addStartAfterDate: ({ date }: addStartAfterDateProps) => void;
  clearStartAfterDate: () => void;
  hasStartAfterDate: boolean;
  setStartDateParam: (starts_date: string) => void;
}

export const useStartAfterDate = (): IUseStartAfterDate => {
  const [starts_date, setQuery] = useQueryParam(
    'starts_date',
    withDefault(StringParam, moment().format('YYYY-MM-DD')),
  );

  const date = moment(starts_date);

  const isToday = date.format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD');

  const addStartAfterDate = ({ date }) => setQuery(date.format('YYYY-MM-DD'), 'replaceIn');

  const clearStartAfterDate = () => setQuery(undefined, 'replaceIn');

  const setStartDateParam = (starts_date) => setQuery(starts_date, 'replaceIn');

  return {
    startsDate: starts_date,
    date,
    addStartAfterDate,
    clearStartAfterDate,
    setStartDateParam,
    hasStartAfterDate: isToday,
  };
};
